var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16.592,
    viewBox: "0 0 14 16.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    transform: "translate(-5 -3.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6815",
    "data-name": "Path 6815",
    d: "M7.4,10H8.99v5a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V10h1.59a1,1,0,0,0,.71-1.71L12.7,3.7a1,1,0,0,0-1.41,0L6.7,8.29A1,1,0,0,0,7.4,10ZM5,19a1,1,0,0,0,1,1H18a1,1,0,0,0,0-2H6A1,1,0,0,0,5,19Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.ea1a6896aea81a1a54a9c1b1ea474375.svg";
export { ForwardRef as ReactComponent };